module.exports = __webpack_public_path__ + "static/media/trofeo3.dd9cd62b.png";